<template>
  <div class="mainDiv">
    <div class="leftDiv">
      <quality-form-configuration-type :parentMsg="parentMsg" @getValue="getValue($event)"/>
    </div>

    <div class="rightDiv">
      <div class="rightTopButton">
        <el-button size="small" type="primary" icon="el-icon-plus" @click="getMaxOrderNum" plain>添加顶级节点</el-button>
        <el-button size="small" type="primary" icon="el-icon-plus" @click="showSettingDialog" plain>添加子节点</el-button>
      </div>
      <div class="tableContent">
        <el-table
          :data="tableData"
          style="width: 100%;"
          height="100%"
          row-key="id"
          border
          size="mini"
          highlight-current-row
          default-expand-all
          @cell-click="tableClicked"
          :header-cell-style="{background:'#ECF5FF',color:'#606266'}"
          :tree-props="{children: 'children'}">
          <el-table-column
            prop="tableName"
            align="left"
            header-align="center"
            :show-overflow-tooltip='true'
            label="名称">
          </el-table-column>
          <el-table-column
            align="center"
            label="前期准备资料"
            width="100px">
            <template slot-scope="scope">
              <span>{{ getDateName(scope.row.dateName) }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="orderNum"
            align="center"
            label="排序号"
            width="80px">
          </el-table-column>
          <el-table-column
            prop="templateCode"
            align="left"
            header-align="center"
            :show-overflow-tooltip='true'
            label="编码">
          </el-table-column>
          <el-table-column
            fixed="right"
            label="操作"
            align="center"
            width="140">
            <template slot-scope="scope">
              <el-tooltip content="查看" placement="top">
                <el-button size="mini" icon="el-icon-view" @click="watchNode(scope.row)" :disabled="watchable(scope.row)" circle plain></el-button>
              </el-tooltip>
              <el-tooltip content="编辑" placement="top">
                <el-button size="mini" type="primary" icon="el-icon-edit" @click="editNode(scope.row)" circle plain></el-button>
              </el-tooltip>
              <el-tooltip content="删除" placement="top">
                <el-button size="mini" type="danger" icon="el-icon-delete" @click="showDeleteAlert(scope.row)" circle plain></el-button>
              </el-tooltip>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>

    <div class="qfcDialogDiv">
      <el-dialog title="分类目录配置" :close-on-click-modal="false" :visible.sync="dialogFormVisible">
        <el-form :model="form">
          <el-row>
            <el-col :span="12">
              <el-form-item label="名称" :label-width="formLabelWidth" prop="tableName">
                <el-input v-model="form.tableName" placeholder="请输入名称"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="排序号" :label-width="formLabelWidth" prop="orderNum">
                <el-input type="number" v-model="form.orderNum" placeholder="请输入排序号"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="是否必须" :label-width="formLabelWidth" prop="isMust">
                <el-radio-group v-model="form.isMust" size="mini">
                  <el-radio :label="1">是</el-radio>
                  <el-radio :label="0">否</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="前期准备资料" :label-width="formLabelWidth" prop="dateName">
                <el-radio-group v-model="form.dateName" size="mini">
                  <el-radio :label='1'>是</el-radio>
                  <el-radio :label='0'>否</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row v-show="!isTopOpen">
            <el-form-item label="编码" :label-width="formLabelWidth" prop="templateCode">
              <el-input v-model="form.templateCode" placeholder="请输入编码"></el-input>
            </el-form-item>
          </el-row>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button type="primary" @click="saveForm" size="medium">确 定</el-button>
          <el-button @click="dialogFormVisible = false" size="medium">取 消</el-button>
        </div>
      </el-dialog>
      <div class="qfcDialogDiv2">
        <el-dialog title="模板配置" :close-on-click-modal="false" :visible.sync="dialogSettingVisible" width="70%" top="10vh">
          <template-configuration-tool :parentMsg="parentMsg2" @getSelectTemplate="getSelectTemplate($event)"/>
          <div slot="footer" class="dialog-footer">
            <el-button type="primary" size="medium" @click="saveTemplates">确 定</el-button>
            <el-button @click="dialogSettingVisible = false" size="medium">取 消</el-button>
          </div>
        </el-dialog>
      </div>
    </div>
  </div>
</template>

<script>
  import QualityFormConfigurationType from '@/components/QualityFormConfigurationType'
  import TemplateConfigurationTool from '@/components/TemplateConfigurationTool'
  import {delContent, getAllContentList, getMaxOrderNum, saveContent, saveExcleContent} from "../api/ppApi";
  export default {
    name: "QualityFormConfiguration",
    components: {
      QualityFormConfigurationType: QualityFormConfigurationType,
      TemplateConfigurationTool: TemplateConfigurationTool
    },
    data() {
      return {
        dialogSettingVisible: false,
        dialogFormVisible: false,
        isTopOpen: false,
        formLabelWidth: '100px',
        selectData: Object,
        params: {},
        form: {},
        tableData:[],
        selectTemplates: [],
        parentMsg: {
          title: '质检表单配置'
        },
        parentMsg2:{}
      }
    },
    methods: {
      getSelectTemplate(templates) {
        this.selectTemplates = templates
      },
      getValue(data) {
        this.params = data
        this.getTableData()
      },
      getTableData() {
        getAllContentList(this.$qs.stringify(this.params)).then(response => {
          if (response.rows !== null) {
            var tree = []
            for (var index in response.rows) {
              let item = response.rows[index]

              if (item.pid === null) {
                tree.push(item)
              } else {
                for (var i in response.rows) {
                  let temp = response.rows[i]

                  if (item.pid === temp.id) {
                    if (temp.children === undefined) {
                      temp.children = [item]
                    } else {
                      temp.children.push(item)
                    }
                    break
                  }
                }
              }
            }

            this.tableData = tree
          }
        }).catch(error => {
          this.tableData = []
          console.log('error:' + error.toString())
        })
        this.selectData = null
      },
      getDateName(dateName) {
        if (dateName === '1') {
          return '是'
        } else {
          return '否'
        }
      },
      getMaxOrderNum() {
        getMaxOrderNum(this.$qs.stringify(this.params)).then(response => {
          if (response.succeed) {
            this.addTopNode(response.data)
          } else {
            console.log('error:' + response.msg)
            this.addTopNode('0')
          }
        }).catch(error => {
          console.log('error:' + error.toString())
          this.addTopNode('0')
        })
      },
      addTopNode(orderNum) {
        this.form = {
          id: '',
          isMust: 1,
          dateName: 0,
          orderNum: orderNum,
          partName: this.params.partName,
          partType: this.params.partType,
          pid: '-1',
          partTypeCode: this.params.partTypeCode,
          partTypeName: this.params.partTypeName,
        }
        this.isTopOpen = true
        this.dialogFormVisible = true
      },
      watchable(data) {
        return data.excelId === null
      },
      watchNode(data) {
        window.open(`http://${window.location.hostname}/loleaflet/dist/loleaflet.html?WOPISrc=http://${window.location.hostname}/api/develop/wopi/files/${data.excelId}&access_token=${localStorage.getItem('Admin-Token')}`)
      },
      editNode(data) {
        this.form = {
          tableName: data.tableName,
          orderNum: data.orderNum,
          isMust: data.isMust === '1' ? 1 : 0,
          dateName: data.dateName === '1' ? 1 : 0,
          id: data.id,
          partName: data.partName,
          partType: data.partType,
          pid: data.pid,
          partTypeCode: data.partTypeCode,
          partTypeName: data.partTypeName,
          templateCode: data.templateCode
        }

        this.isTopOpen = this.watchable(data)
        this.dialogFormVisible = true
      },
      saveForm() {
        saveContent(this.$qs.stringify(this.form)).then(response => {
          if (response.succeed) {
            this.getTableData()
            this.dialogFormVisible = false
          } else {
            this.$message({
              message: response.msg,
              type: 'error'
            })
          }
        }).catch(error => {
          this.$message({
            message: error,
            type: 'error'
          })
        })
      },
      showDeleteAlert(data) {
        this.$confirm('此操作将删除所有子节点和此根节点, 是否继续?', '提示', {
          cancelButtonClass: "btn-custom-cancel",
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.delNode(data)
        })
      },
      delNode(data) {
        delContent(this.$qs.stringify({id:data.id})).then(response => {
          if (response.succeed) {
            this.getTableData()
            this.$message({
              typ: 'success',
              message: '删除成功!'
            });
          } else {
            this.$message({
              message: response.msg,
              showClose: true,
              type: 'error'
            })
          }
        })
      },
      tableClicked(data) {
        this.selectData = data
      },
      showSettingDialog() {
        if (this.selectData == null) {
          this.$message({
            type: 'warning',
            message: '请先选择一个父节点!'
          });
          return
        }
        this.parentMsg2 = {id:this.selectData.id}
        this.dialogSettingVisible = true
      },
      saveTemplates() {
        if (this.selectTemplates.length === 0) {
          this.$message({
            type: 'warning',
            message: '请至少选择一个表单!'
          });
          return
        }

        var templates = []
        for (var index in this.selectTemplates) {
          let item = this.selectTemplates[index]
          templates.push({
            templateId: item.id,
            name: item.name,
            code: item.code,
            remark: item.templateType
          })
        }

        var data = {
          partName: this.selectData.partName,
          partType: this.selectData.partType,
          pid: this.selectData.id,
          isMust: this.selectData.isMust,
          dateName: this.selectData.dateName,
          partTypeCode: this.selectData.partTypeCode,
          partTypeName: this.selectData.partTypeName,
          jsonTemplates:JSON.stringify(templates)
        }

        saveExcleContent(this.$qs.stringify(data)).then(response => {
          if (response.succeed) {
            this.dialogSettingVisible = false
            this.getTableData()
            this.$message({
              typ: 'success',
              message: '保存成功!'
            });
          } else {
            this.$message({
              message: response.msg,
              showClose: true,
              type: 'error'
            })
          }
        }).catch(error => {
          this.$message({
            message: error.toString(),
            showClose: true,
            type: 'error'
          })
        })
      }
    }
  }
</script>

<style>
  .mainDiv {
    height: 100%;
  }
  .leftDiv {
    width: 20%;
    height: 100%;
    float: left;
    background: white;
    margin-right: 5px;
  }
  .rightDiv {
    width: 78%;
    float: right;
    background: white;
    height: 100%;
  }
  .rightName {
    float: left;
    color: black;
    font-size: 18px;
    font-weight: bold;
    margin-left: 15px;
    margin-top: 15px;
  }
  .rightTopButton {
    text-align: left;
    margin-top: 10px;
    margin-left: 10px;
    margin-bottom: 10px;
  }
  .tableContent {
    height: 92.5%;
    height: -webkit-calc(100% - 60px);
    height: calc(100% - 60px);
    overflow: auto;
    margin: 0 10px 0;
  }
  .qfcDialogDiv2 .el-dialog__body {
    height: 400px;
    padding: 10px 20px 0px;
  }
  .qfcDialogDiv .el-dialog__footer {
    padding: 0px 20px 20px;
  }
</style>



// WEBPACK FOOTER //
// src/views/QualityFormConfiguration.vue